import { Box, ToggleSwitch } from "@bcc-ui/ui-components";
import * as React from "react";

import style from "components/dev-tools/dev-tools.scss";
import i18n from "components/i18n";
import * as LanguageRepository from "services/language/languageRepository";
import {
    isFinnishLocalizationEnabled,
    isNewLocalizationEnabled,
    resolveLanguageCode,
} from "services/language/localizationPaths";
import { RepositoryKey, setObject } from "utils/repository";

export const LocalizationSection = () => {
    const handleFinnishToggle = (isEnabled: boolean) => {
        setObject(RepositoryKey.USE_FINNISH_LOCALIZATION, isEnabled);
        const languageCode = resolveLanguageCode(
            LanguageRepository.getLanguage().code,
            isNewLocalizationEnabled(),
            isFinnishLocalizationEnabled()
        );
        i18n.changeLanguage(languageCode);
    };

    return (
        <Box columnLayout gap="Md">
            <Box columnLayout gap="Sm" className={style.contentSection}>
                <ToggleSwitch
                    type="checkbox"
                    name="useFinnishLocalization"
                    label="Use Finnish 🤘"
                    hideLabelSection={false}
                    defaultChecked={isFinnishLocalizationEnabled()}
                    onChange={(event) => handleFinnishToggle(event.target.checked)}
                />
            </Box>
        </Box>
    );
};
